// This component is generated by svgr. DO NOT EDIT.
import { SVGProps } from 'react'
type Props = {
  size?: 'XS' | 'S' | 'M' | 'L' | 'XL' | number, // NOTE: イレギュラーサイズはそのまま数値を渡すようにする
} & Omit<SVGProps<SVGSVGElement>, 'width' | 'height'>
/** @deprecated src/components/iconに定義されている新しいアイコンに置き換えます。
 *
 * 特段の理由がない場合、新規実装でこちらは使用しないでください。 */
const SvgCalendar = ({ size = 'S', ...props }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={
      size === 'XS'
        ? '8px'
        : size === 'S'
        ? '16px'
        : size === 'M'
        ? '24px'
        : size === 'L'
        ? '32px'
        : size === 'XL'
        ? '40px'
        : size
    }
    height={
      size === 'XS'
        ? '8px'
        : size === 'S'
        ? '16px'
        : size === 'M'
        ? '24px'
        : size === 'L'
        ? '32px'
        : size === 'XL'
        ? '40px'
        : size
    }
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <rect
      width={14}
      height={13}
      x={1}
      y={2}
      fill="#fff"
      stroke={props.color ?? 'currentColor'}
      strokeWidth={2}
      rx={1}
    />
    <circle cx={8} cy={9.5} r={1} fill={props.color ?? 'currentColor'} />
    <circle cx={5} cy={9.5} r={1} fill={props.color ?? 'currentColor'} />
    <circle cx={11} cy={9.5} r={1} fill={props.color ?? 'currentColor'} />
    <circle cx={8} cy={12.5} r={1} fill={props.color ?? 'currentColor'} />
    <circle cx={5} cy={12.5} r={1} fill={props.color ?? 'currentColor'} />
    <path stroke={props.color ?? 'currentColor'} strokeWidth={2} d="M2 6h12" />
    <path
      stroke={props.color ?? 'currentColor'}
      strokeLinecap="round"
      strokeWidth={2}
      d="M5 1v2M11 1v2"
    />
  </svg>
)
export default SvgCalendar
